import moment from "moment";
import React, { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import DatePicker from "react-multi-date-picker";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { Link, useNavigate } from "react-router-dom";
import Loader from "../../component/Loader";
import Paginations from "../../component/Pagination";
import { areaCodeListingSelector, FetchAreaCodeList } from "../areacode/slice";
import { SchoolListReducer } from "../slice";
import { FetchEarnings, listing } from "./PaymentSlice";
import { Modal } from "react-bootstrap";
import { getTeacherId } from "../../app/globalStore";

function EarningByTeacher() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacher_id = getTeacherId();
  const list = useSelector((state) => state?.payment?.list);
  const total = useSelector((state) => state?.payment?.total);
  const adminPercent = useSelector((state) => state?.payment?.adminPercent);
  const [show, setShow] = useState(false);
  const [start_date, setStart_date] = useState("");
  const [end_date, setEnd_date] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState("1");
  const [search, setSearch] = useState("");

  let companyOptions = [];
  const companiesStr = localStorage.getItem('companies');
  if (companiesStr) {
    try {
      const companies = JSON.parse(companiesStr);
      if (Array.isArray(companies) && companies.length > 0) {
        companyOptions = [
          { value: 0, label: 'All Companies' },
          ...companies.map(c => ({
            value: c.id,
            label: c.company_name
          }))
        ];
      }
    } catch (e) {
      // Optionally handle JSON parse error
      companyOptions = [];
    }
  }
  const [selectedCompany, setSelectedCompany] = useState(0);

  const [schoolId, setSchoolId] = useState("");
  const [areacode, setAreacode] = useState("");
  const Schoollist = useSelector((state) => state.main.schools) || [];
  const arealist = useSelector(areaCodeListingSelector) || [];
  const [limit, setLimit] = useState(10);
  const [amount, setAmount] = useState({
    total: 0,
    netTotal: 0,
    adminEarning: 0,
  });
  const filteredList = Array.isArray(list)
    ? list.filter((item) => Number(item?.teacher_id) > 0)
    : [];
  useEffect(() => {
    dispatch(FetchAreaCodeList({ page: 1, limit: 100000000, company_id:selectedCompany }));
  }, [dispatch, selectedCompany]);

  useEffect(() => {
    if (areacode) {
      dispatch(
        SchoolListReducer({
          page: 1,
          limit: 100000000,
          search: "",
          areacode,
        })
      );
    }
  }, [dispatch, areacode]);

  useEffect(() => {
    setLoading(true);
    dispatch(
      FetchEarnings({
        page: page,
        limit,
        search,
        type: "teacher",
        areacode,
        schoolId,
        company_id: selectedCompany,
        ...(start_date && { start_date: moment(start_date).format("YYYY-MM-DD") }),
        ...(end_date && { end_date: moment(end_date).format("YYYY-MM-DD") })
      })
    ).then((res) => {
      setLoading(false);
      let arr = res?.payload?.data?.earning_list;
      var total = 0;
      var netTotal = 0;
      let adminEarning = 0;
      arr.forEach((values) => {
        total += Number(values.total_amount);
        adminEarning += (Number(values.total_amount) * 10) / 100;
        netTotal = total - adminEarning;
      });

      setAmount({
        total: parseFloat(total).toFixed(2),
        netTotal: parseFloat(netTotal).toFixed(2),
        adminEarning: parseFloat(adminEarning).toFixed(2),
      });
    });
  }, [dispatch, page, search, areacode, schoolId, limit, selectedCompany, start_date, end_date]);

  useEffect(() => {
    return () => {
      dispatch(listing([]));
    };
  }, [dispatch]);

  const getCsvData = () => {
    let arr = [...list];
    let datas = arr.map((earning) => {
      return {
        teacher_name: earning?.teacher_details?.full_name,
        class_name: earning?.class_details?.name,
        class_type: earning?.class_details?.class_type,
        date: moment(earning?.date).format("DD MMM YYYY"),
        gross_amount: earning?.total_amount,
        admin_percentage: "10%",
        admin_earnings: (earning?.total_amount * 10) / 100,
        net_erarning:
          earning?.total_amount - (earning?.total_amount * 10) / 100,
      };
    });
    return datas;
  };
  const handleSubmit = () => {
    dispatch(
      FetchEarnings({
        page: page,
        limit: 10,
        search,
        type: "teacher",
        areacode,
        schoolId,
        start_date: moment(start_date).format("YYYY-MM-DD"),
        end_date: moment(end_date).format("YYYY-MM-DD"),
        company_id: selectedCompany
      })
    ).then((res) => {
      if (res?.payload?.code === 1) {
        setShow(!show);
      }
    });
  };

  return (
    <article className="col-lg-9">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-7 col-xl-7 mb-3">
            <ul
              className="nav nav-pills group-nav mb-0 mt-0 payment-refund"
              id="pills-tab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <Link to="/earnings-by-staff" className="nav-link active">
                  earnings by teacher
                </Link>
              </li>
              {teacher_id <= 0 && (
                <li className="nav-item" role="presentation">
                  <Link to="/earnings-by-membership" className="nav-link">
                    earnings by membership
                  </Link>
                </li>
              )}
              {/* <li className="nav-item" role="presentation">
                <Link to="/refund" className="nav-link">
                  refund
                </Link>
              </li> */}
            </ul>
          </div>
        </div>
        <div className="row align-items-end g-2 mt-3">
          <div className="col-md-2">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search w-100">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search by teacher"
                  value={search}
                  onChange={(e) => {
                    setPage(1);
                    setSearch(e.target.value);
                  }}
                />
              </form>
            </div>
          </div>
          {Array.isArray(companyOptions) && companyOptions.length > 0 && (
            <div className="col-md-2">
              <Select
                className="form-control"
                options={companyOptions}
                isSearchable
                placeholder="Select a company..."
                defaultValue={companyOptions[selectedCompany]}
                onChange={option => {
                  setSelectedCompany(option.value);
                }}
              />
            </div>
          )}
          <div className="col-md-2">
            <DatePicker
              value={start_date}
              onChange={(val) => {
                setStart_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
              placeholder="Start Date"
              className="custom-datepicker"
            />
          </div>
          <div className="col-md-2">
            <DatePicker
              value={end_date}
              onChange={(val) => {
                setEnd_date(val.toDate());
              }}
              containerStyle={{width: '100%'}}
              style={{borderRadius: '10px', border: '1px solid #ced4da', padding: '0.5rem 0.75rem', fontSize: '0.95rem', outline: 'none', boxShadow: 'none', backgroundColor: '#fff', height: '50px', width: '100%'}}
              placeholder="End Date"
              minDate={start_date || new Date()}
              className="custom-datepicker"
            />
          </div>
                  <div className="col-md-2">
                    <select
                      className="form-control form-select"
                      onChange={(e) => {
                        if (e.target.value === "") {
                          setSchoolId("");
                        }
                        setAreacode(e.target.value);
                      }}
                    >
              <option value="">Select Region</option>
              {Array.isArray(arealist) && arealist.map((item, i) => (
                <option value={item?.id} key={i}>
                  {item?.areacode}
                </option>
              ))}
            </select>
          </div>
          {areacode && (
            <div className="col-md-2">
              <select
                className="form-control form-select"
                onChange={(e) => {
                  setSchoolId(e.target.value);
                }}
              >
                <option value="">Select Location</option>
                {Schoollist?.map((item, i) => (
                  <option value={item?.id} key={i}>
                    {item?.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-md-2 text-end ms-auto">
            {filteredList && (
              <CSVLink
                filename={"earnings.csv"}
                data={filteredList?.length ? getCsvData() : []}
              >
                <button type="button" className="btn btn-save p-2 fs-6">
                  Download CSV
                </button>
              </CSVLink>
            )}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">Id</th>
                    <th scope="col">Teacher name</th>
                    <th scope="col">Gross Amount</th>
                    <th scope="col">Franchise Fee</th>
                    <th scope="col">Hall Fee</th>
                    <th scope="col">Admin Commission</th>
                    <th scope="col">Teacher Net Income</th>
                    <th scope="col">Admin Net Income</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                  <tr>
                    <td colSpan={9} style={{ textAlign: "center", padding: "20px" }}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                        <div className="spinner"></div>
                        <p style={{ fontSize: "14px", color: "#555", margin: 0 }}>
                          Please wait... Teacher earnings are being generated.
                        </p>
                      </div>
                    </td>
                  </tr>                
                  ) : filteredList?.length > 0 ? (
                    filteredList?.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item?.teacher_id || "NA"}</td>
                          <td>
                            <div className="d-flex align-items-center gap-2">
                              <img 
                                src={item?.teacher_details?.image || "assets/images/upload-img.png"} 
                                alt={item?.teacher_details?.full_name} 
                                style={{
                                  width: '40px', 
                                  height: '40px', 
                                  borderRadius: '50%', 
                                  objectFit: 'cover'
                                }} 
                              />
                              <span>{item?.teacher_details?.full_name || "NA"}</span>
                            </div>
                          </td>
                          <td style={{color: '#2196F3', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {parseFloat(item?.total_amount || 0).toFixed(2)}
                          </td>
                          <td style={{color: '#FF9800', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {parseFloat(item?.total_franchise_fee || 0).toFixed(2)}
                          </td>
                          <td style={{color: '#FF9800', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {parseFloat(item?.total_hall_fee || 0).toFixed(2)}
                          </td>
                          <td style={{color: '#FF9800', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {(() => {
                              const totalAmount = parseFloat(item?.total_amount || 0);
                              const hallFee = parseFloat(item?.total_hall_fee || 0);
                              const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                              const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                              return adminCommission.toFixed(2);
                            })()}
                          </td>
                          <td style={{color: '#15c51d', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {(() => {
                              const totalAmount = parseFloat(item?.total_amount || 0);
                              const hallFee = parseFloat(item?.total_hall_fee || 0);
                              const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                              const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                              const adminNetIncome = hallFee + franchiseFee + adminCommission;
                              const teacherNetIncome = totalAmount - adminNetIncome;
                              return teacherNetIncome.toFixed(2);
                            })()}
                          </td>
                          <td style={{color: '#15c51d', fontWeight: '450'}}>
                            <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                            {(() => {
                              const totalAmount = parseFloat(item?.total_amount || 0);
                              const hallFee = parseFloat(item?.total_hall_fee || 0);
                              const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                              const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                              const adminNetIncome = hallFee + franchiseFee + adminCommission;
                              return adminNetIncome.toFixed(2);
                            })()}
                          </td>

                          <td>
                            <div className="d-flex justify-content-center action">
                              <button className="btn">
                                <Link
                                  to={`/earnings-by-staff/${item?.teacher_id}`}
                                >
                                  <img src="assets/images/view.png" alt="" />
                                </Link>
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>No data found.</td>
                    </tr>
                  )}
                  {filteredList?.length > 0 && (
                    <tr style={{backgroundColor: '#f8f9fa', fontWeight: 'bold', borderTop: '2px solid #dee2e6'}}>
                      <td colSpan={2} style={{textAlign: 'right', padding: '12px'}}>
                        <b>Total:</b>
                      </td>
                      <td style={{color: '#2196F3', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => sum + parseFloat(item?.total_amount || 0), 0).toFixed(2)}
                      </td>
                      <td style={{color: '#FF9800', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => sum + parseFloat(item?.total_franchise_fee || 0), 0).toFixed(2)}
                      </td>
                      <td style={{color: '#FF9800', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => sum + parseFloat(item?.total_hall_fee || 0), 0).toFixed(2)}
                      </td>
                      <td style={{color: '#FF9800', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => {
                          const totalAmount = parseFloat(item?.total_amount || 0);
                          const hallFee = parseFloat(item?.total_hall_fee || 0);
                          const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                          const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                          return sum + adminCommission;
                        }, 0).toFixed(2)}
                      </td>
                      <td style={{color: '#15c51d', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => {
                          const totalAmount = parseFloat(item?.total_amount || 0);
                          const hallFee = parseFloat(item?.total_hall_fee || 0);
                          const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                          const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                          const adminNetIncome = hallFee + franchiseFee + adminCommission;
                          const teacherNetIncome = totalAmount - adminNetIncome;
                          return sum + teacherNetIncome;
                        }, 0).toFixed(2)}
                      </td>
                      <td style={{color: '#15c51d', fontWeight: '600', padding: '12px'}}>
                        <i className="fa fa-gbp" aria-hidden="true"></i>{" "}
                        {filteredList.reduce((sum, item) => {
                          const totalAmount = parseFloat(item?.total_amount || 0);
                          const hallFee = parseFloat(item?.total_hall_fee || 0);
                          const franchiseFee = parseFloat(item?.total_franchise_fee || 0);
                          const adminCommission = ((totalAmount - (hallFee + franchiseFee)) * adminPercent) / 100;
                          const adminNetIncome = hallFee + franchiseFee + adminCommission;
                          return sum + adminNetIncome;
                        }, 0).toFixed(2)}
                      </td>
                      <td></td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {filteredList?.length > 0 && (
              <div className="text-center">
                <span
                  className={
                    limit === 10
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setPage("1");
                    setLimit(10);
                  }}
                >
                  10
                </span>
                <span
                  className={
                    limit === 25
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setPage("1");
                    setLimit(25);
                  }}
                >
                  25
                </span>
                <span
                  className={
                    limit === 100
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setPage("1");
                    setLimit(100);
                  }}
                >
                  100
                </span>
                <span
                  className={
                    limit === ""
                      ? "manualPagination active"
                      : "manualPagination"
                  }
                  onClick={() => {
                    setLimit("");
                    // setPage("");
                  }}
                >
                  All
                </span>
              </div>
            )}
          </div>
          {/* {list?.length > 0 && total > 10 && (
            <Paginations
              handlePage={(val) => {
                setPage(val);
              }}
              page={page}
              total={total && total}
            />
          )} */}
        </div>
      </div>
      <div
        class="modal fade"
        id="FilterModal"
        tabindex="-1"
        aria-labelledby="FilterModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content body-bg">
            <div class="modal-header border-0 justify-content-center">
              <h6>Filter</h6>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body mb-4">
              <form class="form-style">
                <div class="form-group">
                  <h5>By Teacher</h5>
                  <select class="form-control form-select">
                    <option>Select Teacher Name</option>
                  </select>
                </div>
                <div class="form-group">
                  <h5>Select Date</h5>
                  <div class="input-container">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Date"
                    />
                    <img
                      src="assets/images/choose-date.png"
                      class="field-icon"
                      alt=""
                    />
                  </div>
                </div>
                <div class="text-center">
                  <a href="#" class="text-dark">
                    Reset All
                  </a>
                </div>
                <div class="text-center">
                  <button class="btn btn-accept btn-view mt-2">Apply</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => {
          setShow(!show);
        }}
        centered
        size="md"
      >
        <div class="modal-content body-bg p-3">
          <div class="modal-header border-0 justify-content-center">
            <h6>Filter</h6>
            <button
              type="button"
              class="btn-close"
              onClick={() => {
                setShow(!show);
              }}
            ></button>
          </div>
          <div class="modal-body mb-4">
            <form class="form-style">
              {/* <div class="form-group">
                  <h5>By Teacher</h5>
                  <select class="form-control form-select">
                    <option>Select Teacher Name</option>
                  </select>
                </div> */}
              <div class="form-group">
                <h5>Start Date</h5>
                <div class="input-container">
                  {/* <input
                      type="text"
                      class="form-control"
                      placeholder="Date"
                    /> */}
                  <DatePicker
                    value={start_date}
                    onChange={(val) => {
                      setStart_date(val.toDate());
                    }}
                    containerClassName="form-control"
                  />
                  <img
                    src="assets/images/choose-date.png"
                    class="field-icon"
                    alt=""
                  />
                </div>
              </div>
              <div class="form-group">
                <h5>End Date</h5>
                <div class="input-container">
                  {/* <input
                      type="text"
                      class="form-control"
                      placeholder="Date"
                    /> */}
                  <DatePicker
                    value={end_date}
                    onChange={(val) => {
                      setEnd_date(val.toDate());
                    }}
                    containerClassName="form-control"
                    minDate={start_date || new Date()}
                  />
                  <img
                    src="assets/images/choose-date.png"
                    class="field-icon"
                    alt=""
                  />
                </div>
              </div>
              <div class="text-center">
                <span
                  onClick={() => {
                    setStart_date("");
                    setEnd_date("");
                  }}
                  className="text-dark cursor-pointer"
                >
                  Reset
                </span>
              </div>
              <div class="text-center">
                <button
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                  class="btn btn-accept btn-view mt-2"
                >
                  Apply
                </button>
              </div>
            </form>
          </div>
        </div>
      </Modal>
    </article>
  );
}

export default EarningByTeacher;
